import React from 'react';
function Galeria() {
    return (
      <div>
          Galeria
      </div>
    );
  }
  
  export default Galeria;